export class UserConfiguration {
  ehealthKeyStorePasswordKey: string;
  helenaEnabled: boolean;
  helenaActivationQuestionVisit: boolean;

  constructor(
    ehealthKeyStorePasswordKey: string,
    helenaEnabled: boolean,
    helenaActivationQuestionVisit: boolean
  ) {
    this.ehealthKeyStorePasswordKey = ehealthKeyStorePasswordKey;
    this.helenaEnabled = helenaEnabled;
    this.helenaActivationQuestionVisit = helenaActivationQuestionVisit;
  }
}
